import { render, staticRenderFns } from "./RegisteredField.vue?vue&type=template&id=39c7dc41"
import script from "./RegisteredField.vue?vue&type=script&lang=js"
export * from "./RegisteredField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports